import { render, staticRenderFns } from "./ArchiveList.html?vue&type=template&id=540e8a22&scoped=true&"
import script from "./ArchiveList.vue?vue&type=script&lang=js&"
export * from "./ArchiveList.vue?vue&type=script&lang=js&"
import style0 from "./ArchiveList.vue?vue&type=style&index=0&id=540e8a22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540e8a22",
  null
  
)

export default component.exports